module.exports = __webpack_public_path__ + "static/media/logo-dark-mobile.a63810d3.svg";